<template>
  <validation-observer v-slot="{ errors }">
    <hr />
    <HeaderWithIcon title="Contact Details" />
    <div class="address-field">
      <postcode-search
        :hasErrors="
          Object.values(errors)
            .flat()
            .some((x) => x)
        "
        @place-change="mapAddress"
      />

      <section v-if="addressSelected && !editingAddress">
        <div class="selected-address">
          <p>Your Address</p>
          <ul>
            <li>{{ fields[0].value }}</li>
            <li>{{ fields[1].value }}</li>
            <li>{{ fields[2].value }}</li>
            <li>{{ fields[3].value }}</li>
            <li>
              {{ countries[fields[4].value] }}
            </li>
          </ul>
        </div>
      </section>

      <div style="margin-bottom: 1em; text-align: right;">
        <button type="button" @click="handleAddressEdit" class="btn btn--link">
          <template v-if="!editingAddress">
            <span v-if="!addressSelected">Enter manually</span>
            <span v-if="addressSelected">Edit address</span>
          </template>
          <template v-else>
            <span>Cancel</span>
          </template>
        </button>
      </div>

      <div
        :class="{
          'address-field__hidden': !editingAddress,
          'address-fields__visible': editingAddress,
        }"
      >
        <div
          v-for="field in fields"
          :key="field.key"
          class="form-control__item"
          :form-control-for="field.key"
        >
          <form-field-renderer :item="field" :fields="fields" />
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import HeaderWithIcon from "@/components/HeaderWithIcon.vue";
import PostcodeSearch from "@/components/PostcodeSearch";
import { registrationConfig } from "@/helpers/config";
import { useMemberDetails } from "@/helpers/member-details";
import { ref } from "@vue/composition-api";
import { ValidationObserver } from "vee-validate";

export default {
  props: ["item"],
  components: {
    HeaderWithIcon,
    FormFieldRenderer: () => import("@/components/FormFieldRenderer.vue"),
    PostcodeSearch,
    ValidationObserver,
  },
  setup(props) {
    const addressSelected = ref(false);
    const editingAddress = ref(false);
    const { countries } = registrationConfig;
    const { fields } = props.item;
    const details = useMemberDetails();

    fields.forEach((f) => {
      if (!f.maxlength) f.maxlength = 75;

      f.rules = f.rules || [];
      f.validation = f.rules.join("|");
      if (f.rules.includes("required")) f.required = true;
    });

    for (const field of fields) {
      if (details[field.key]) {
        field.value = details[field.key].value;
      }
    }

    if (fields.some((x) => x.value && x.value !== "")) {
      addressSelected.value = true;
    }

    const handleAddressEdit = () =>
      (editingAddress.value = !editingAddress.value);

    const mapAddress = (selectedAddress) => {
      fields[0].value = `${selectedAddress.Line1}, ${selectedAddress.Line2}`;
      fields[1].value = `${selectedAddress.City}`;
      fields[2].value = `${
        selectedAddress.Province !== ""
          ? selectedAddress.Province
          : selectedAddress.AdminAreaName
      }`;
      fields[3].value = `${selectedAddress.PostalCode}`;
      fields[4].value = `${selectedAddress.CountryIso3}`;
      addressSelected.value = true;
    };

    return {
      addressSelected,
      countries,
      editingAddress,
      fields,
      handleAddressEdit,
      mapAddress,
    };
  },
};
</script>

<style lang="scss" scoped>
.address-field {
  width: 100%;

  .form-control__item {
    margin-left: 0;
  }

  &__hidden {
    display: none;
  }
}
</style>
